/** @format */

import React, { useState } from "react";
import logo from "../component/images/aman.jpg";

const Todo = () => {
  const [inputData, setInputData] = useState();
  const [items, setItems] = useState([]);

  const addItem = () => {
    if (!inputData) {
      alert("Item can't be empty");
    } else {
      setItems([...items, inputData]);
      setInputData("");
    }
  };

  const deleteItem = (id) => {
    const updatedItems = items.filter((elem, index) => {
      return index !== id;
    });

    setItems(updatedItems);
  };

  const removeAll = () => {
    setItems([]);
  };

  return (
    <>
      <div className='main-div'>
        <div className='child-div'>
          <figure>
            <img src={logo} alt='my logo' />
            <figcaption>Welcome to My ToDo App</figcaption>
          </figure>
          <div className='addItems'>
            <input
              type='text'
              placeholder='Add Items'
              value={inputData}
              onChange={(e) => {
                setInputData(e.target.value);
              }}
            />
            <i
              className='fa fa-plus add-btn'
              title='Add Item'
              onClick={addItem}
            ></i>
          </div>

          <div className='showItems'>
            {items.map((elem, index) => {
              return (
                <div className='eachItem' key={index}>
                  <h3>{elem}</h3>
                  <i
                    className='far fa-trash-alt add-btn'
                    title='Delete Item'
                    onClick={() => deleteItem(index)}
                  ></i>
                </div>
              );
            })}
          </div>

          {/* ClearAll Button */}
          <div className='showItems'>
            <button
              className='btn effect-04'
              data-sn-link-text='Remove All'
              onClick={removeAll}
            >
              <span> Clear List</span>
            </button>
          </div>
        </div>
      </div>
      <footer>
        <p>Copyright ©️ AmaN 2022</p>
      </footer>
    </>
  );
};

export default Todo;
